import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: false,
  },
  mutations: {
    changeSize (state) {
      state.isMobile = !state.isMobile
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    isMobile(state) {
      return state.isMobile
    }
  }
})
